module.exports = {"id":"193148","name":"Vincent Le Goff","rating":"71","photo":"./data/images/photos/1/193148.png","club":{"name":"FC Lorient","logo":"./data/images/clubs/FCLorient.png"},"positions":["DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VincentLeGoff0.json
// module id = 4279
// module chunks = 0